export const knowledgeAdminRoutes = [
  {
    path: "/intelligence-center",
    name: "intelligenceCenter",
    icon: "robot",
    access: "canManageIntelligence",
    routes: [
      {
        path: "",
        redirect: "/intelligence-center/dashboard",
      },
      {
        path: "dashboard",
        name: "intelligenceCenterDashboard",
        icon: "dashboard",
        component: "./platform-intelligence/DashboardPage",
      },
      {
        path: "model-connections",
        name: "intelligenceModelConnections",
        icon: "link",
        component: "./platform-intelligence/ModelConnectionsPage",
      },
      {
        path: "provider-configs",
        name: "intelligenceProviderConfigs",
        icon: "setting",
        component: "./platform-intelligence/ProviderConfigsPage",
      },
      {
        path: "task-runs",
        name: "intelligenceTaskRuns",
        icon: "playSquare",
        component: "./platform-intelligence/TaskRunsPage",
      },
      {
        path: "audit-logs",
        name: "intelligenceAuditLogs",
        icon: "audit",
        component: "./platform-intelligence/AuditLogsPage",
      },
    ],
  },
  {
    path: "/business-reference-center",
    name: "businessReferenceCenter",
    icon: "link",
    access: "canManageBusinessReference",
    routes: [
      {
        path: "",
        redirect: "/business-reference-center/dashboard",
      },
      {
        path: "dashboard",
        name: "businessReferenceCenterDashboard",
        icon: "dashboard",
        component: "./platform-business-reference-center/DashboardPage",
      },
      {
        path: "resource-types",
        name: "businessReferenceResourceTypes",
        icon: "database",
        component: "./platform-business-reference-center/ResourceTypesPage",
      },
      {
        path: "relation-types",
        name: "businessReferenceRelationTypes",
        icon: "branches",
        component: "./platform-business-reference-center/RelationTypesPage",
      },
      {
        path: "references",
        name: "businessReferenceReferences",
        icon: "deploymentUnit",
        component: "./platform-business-reference-center/ReferencesPage",
      },
    ],
  },
  {
    path: "/tools-library",
    name: "toolsLibrary",
    icon: "tool",
    access: "canManagePlatform",
    routes: [
      {
        path: "",
        redirect: "/tools-library/tools",
      },
      {
        path: "tools",
        name: "toolsLibraryTools",
        icon: "tool",
        component: "./platform-tools-library/ToolsPage",
      },
      {
        path: "categories",
        name: "toolsLibraryCategories",
        icon: "tags",
        component: "./platform-tools-library/CategoriesPage",
      },
    ],
  },
  {
    path: "/traffic-library",
    name: "trafficLibrary",
    icon: "deploymentUnit",
    access: "canManageTrafficLibrary",
    routes: [
      {
        path: "",
        redirect: "/traffic-library/packet-files",
      },
      {
        path: "packet-files",
        name: "trafficLibraryPacketFiles",
        icon: "fileSearch",
        component: "./platform-traffic-library/PacketFilesPage",
      },
      {
        path: "categories",
        name: "trafficLibraryCategories",
        icon: "tags",
        component: "./platform-traffic-library/CategoriesPage",
      },
    ],
  },
  {
    path: "/knowledge-library",
    name: "knowledgeLibrary",
    icon: "book",
    access: "canManagePlatform",
    routes: [
      {
        path: "",
        redirect: "/knowledge-library/items",
      },
      {
        path: "items",
        name: "knowledgeLibraryItems",
        icon: "book",
        component: "./platform-knowledge-library/ItemsPage",
      },
      {
        path: "categories",
        name: "knowledgeLibraryCategories",
        icon: "tags",
        component: "./platform-knowledge-library/CategoriesPage",
      },
    ],
  },
  {
    path: "/capability-graph",
    name: "capabilityGraph",
    icon: "cluster",
    access: "canManageCapabilityGraph",
    routes: [
      {
        path: "",
        redirect: "/capability-graph/dashboard",
      },
      {
        path: "dashboard",
        name: "capabilityGraphDashboard",
        icon: "dashboard",
        component: "./platform-capability-graph/DashboardPage",
      },
      {
        path: "capabilities",
        name: "capabilityGraphCapabilities",
        icon: "table",
        component: "./platform-capability-graph/CapabilitiesPage",
      },
      {
        path: "capabilities/:capabilityKey",
        name: "capabilityGraphCapabilityDetail",
        hideInMenu: true,
        component: "./platform-capability-graph/CapabilityDetailPage",
      },
      {
        path: "ksa-categories",
        name: "capabilityGraphKsaCategories",
        icon: "tags",
        routes: [
          {
            path: "",
            redirect: "/capability-graph/ksa-categories/knowledge",
          },
          {
            path: "knowledge",
            name: "capabilityGraphKsaKnowledgeCategories",
            component: "./platform-capability-graph/KsaKnowledgeCategoriesPage",
          },
          {
            path: "skill",
            name: "capabilityGraphKsaSkillCategories",
            component: "./platform-capability-graph/KsaSkillCategoriesPage",
          },
          {
            path: "ability",
            name: "capabilityGraphKsaAbilityCategories",
            component: "./platform-capability-graph/KsaAbilityCategoriesPage",
          },
        ],
      },
      {
        path: "graph",
        name: "capabilityGraphGraph",
        icon: "apartment",
        component: "./platform-capability-graph/GraphPage",
      },
    ],
  },
  {
    path: "/tactics-techniques-hub",
    name: "tacticsTechniquesHub",
    icon: "apartment",
    access: "canManageTacticsTechniques",
    routes: [
      {
        path: "",
        redirect: "/tactics-techniques-hub/dashboard",
      },
      {
        path: "dashboard",
        name: "tacticsTechniquesDashboard",
        icon: "dashboard",
        component: "./platform-tactics-techniques/DashboardPage",
      },
      {
        path: "frameworks",
        name: "tacticsTechniquesFrameworks",
        icon: "table",
        component: "./platform-tactics-techniques/FrameworksPage",
      },
      {
        path: "binding-playground",
        name: "tacticsTechniquesBindingPlayground",
        icon: "link",
        component: "./platform-tactics-techniques/BindingPlaygroundPage",
      },
      {
        path: "api-reference",
        name: "tacticsTechniquesApiReference",
        icon: "book",
        component: "./platform-tactics-techniques/ApiReferencePage",
      },
      {
        path: "frameworks/:frameworkKey/matrix",
        name: "tacticsTechniquesFrameworkMatrix",
        hideInMenu: true,
        component: "./platform-tactics-techniques/FrameworkMatrixPage",
      },
      {
        path: "frameworks/:frameworkKey/tree",
        name: "tacticsTechniquesFrameworkTree",
        hideInMenu: true,
        component: "./platform-tactics-techniques/FrameworkTreePage",
      },
      {
        path: "frameworks/:frameworkKey/version-mappings",
        name: "tacticsTechniquesFrameworkVersionMappings",
        hideInMenu: true,
        component: "./platform-tactics-techniques/FrameworkVersionMappingsPage",
      },
    ],
  },
  {
    path: "/vulnerability-library",
    name: "vulnerabilityLibrary",
    icon: "safetyCertificate",
    access: "canManageVulnerabilityLibrary",
    routes: [
      {
        path: "",
        redirect: "/vulnerability-library/dashboard",
      },
      {
        path: "dashboard",
        name: "vulnerabilityLibraryDashboard",
        icon: "dashboard",
        component: "./platform-vulnerability-library/DashboardPage",
      },
      {
        path: "vulnerabilities",
        name: "vulnerabilityLibraryVulnerabilities",
        icon: "bug",
        component: "./platform-vulnerability-library/VulnerabilitiesPage",
      },
      {
        path: "vulnerabilities/:vulnerabilityCode",
        name: "vulnerabilityLibraryVulnerabilityDetail",
        hideInMenu: true,
        component: "./platform-vulnerability-library/VulnerabilityDetailPage",
      },
      {
        path: "sources",
        name: "vulnerabilityLibrarySources",
        icon: "database",
        component: "./platform-vulnerability-library/SourcesPage",
      },
      {
        path: "source-records",
        name: "vulnerabilityLibrarySourceRecords",
        icon: "profile",
        component: "./platform-vulnerability-library/SourceRecordsPage",
      },
      {
        path: "source-records/:sourceRecordCode",
        name: "vulnerabilityLibrarySourceRecordDetail",
        hideInMenu: true,
        component: "./platform-vulnerability-library/SourceRecordDetailPage",
      },
      {
        path: "import-jobs",
        name: "vulnerabilityLibraryImportJobs",
        icon: "import",
        component: "./platform-vulnerability-library/ImportJobsPage",
      },
    ],
  },
];
